import React from "react";
var __jsx = React.createElement;
import styled from 'styled-components';
import * as ds from '@bob/design-system';
import { styles as S } from '@bob/design-system';
export var Aside = styled.div.withConfig({
  displayName: "ListingLayout__Aside",
  componentId: "sc-52gp07-0"
})(["@media screen and (", "){margin-right:30px;}@media not screen and (", "){margin-right:0px;}"], ds.breakpoint.TABLET, ds.breakpoint.MOBILE_L);
export var Controls = styled.div.withConfig({
  displayName: "ListingLayout__Controls",
  componentId: "sc-52gp07-1"
})(["align-items:center;display:flex;justify-content:space-between;margin-bottom:35px;margin-top:12px;"]);
export var DesktopContainer = styled.div.withConfig({
  displayName: "ListingLayout__DesktopContainer",
  componentId: "sc-52gp07-2"
})(["display:none;@media screen and (", "){display:block;}"], ds.breakpoint.TABLET);
export function Heading(_ref) {
  var children = _ref.children,
      color = _ref.color,
      description = _ref.description,
      title = _ref.title;
  return __jsx(HeadingWrapper, null, __jsx(BrushTitle, null, __jsx(S.heading.Title2, {
    as: "h1"
  }, title), __jsx(ds.brush.full.FullBrush3, {
    style: {
      color: color
    }
  })), description && __jsx(S.copy.Text1, {
    as: "h2"
  }, description), children);
}
var BrushTitle = styled.div.withConfig({
  displayName: "ListingLayout__BrushTitle",
  componentId: "sc-52gp07-3"
})(["position:relative;", "{height:100%;min-height:3.5rem;left:0;position:absolute;top:-0.5rem;width:12rem;z-index:-1;@media screen and (", "){top:-1rem;height:6rem;width:18rem;}}"], ds.brush.Brush, ds.breakpoint.TABLET);
export var HeadingWrapper = styled.div.withConfig({
  displayName: "ListingLayout__HeadingWrapper",
  componentId: "sc-52gp07-4"
})(["margin-top:20px;", "{margin-top:20px;max-width:400px;@media screen and (", "){max-width:50%;}}"], S.copy.Text1, ds.breakpoint.TABLET);
export var Item = styled.li.withConfig({
  displayName: "ListingLayout__Item",
  componentId: "sc-52gp07-5"
})(["width:100%;@media screen and (min-width:600px){width:46%;}@media screen and (", "){width:100%;}"], ds.breakpoint.TABLET);
export var Main = styled.div.withConfig({
  displayName: "ListingLayout__Main",
  componentId: "sc-52gp07-6"
})([""]);
export var MobileContainer = styled.div.withConfig({
  displayName: "ListingLayout__MobileContainer",
  componentId: "sc-52gp07-7"
})(["display:block;@media screen and (", "){display:none;}"], ds.breakpoint.TABLET);
export var Pagination = styled.div.withConfig({
  displayName: "ListingLayout__Pagination",
  componentId: "sc-52gp07-8"
})(["display:flex;justify-content:center;align-items:center;margin:50px 0 50px;"]);
export var Wrapper = styled.div.withConfig({
  displayName: "ListingLayout__Wrapper",
  componentId: "sc-52gp07-9"
})(["position:relative;display:grid;grid-template-columns:repeat(1,100%);@media screen and (", "){grid-template-columns:repeat(4,25%);", "{grid-area:1 / 1 / span 3 / span 2;}", "{grid-area:1 / 3 / span 3 / span 3;}}@media screen and (", "){grid-template-columns:33% 1fr 1fr 1fr;", "{grid-area:1 / 1 / span 3 / span 1;}", "{grid-area:1 / 2 / span 3 / span 3;}}@media screen and (min-width:1240px){grid-template-columns:repeat(4,25%);", "{grid-area:1 / 1 / span 3 / span 1;}", "{grid-area:1 / 2 / span 3 / span 3;}}"], ds.breakpoint.TABLET, Aside, Main, ds.breakpoint.LAPTOP, Aside, Main, Aside, Main);
export var ScrollAnchor = styled.div.withConfig({
  displayName: "ListingLayout__ScrollAnchor",
  componentId: "sc-52gp07-10"
})(["position:absolute;z-index:-1;top:-20px;@media screen and (", "){top:-65px;}"], ds.breakpoint.TABLET);